import {Component, createRef} from 'preact';

const BUTTON_NAMES = ['знаток', 'эксперт', 'магистр'];
const TESTS_NUMBER = 3;

const gameControlButtons = document.querySelectorAll('.footer__controls-button');

export default class NewTestButton extends Component {
  constructor(props){
    super(props);

    this._LS_PASSED_GAMES_KEY = 'completed tests';
    this.passedTests = [];
    this.testId = this.props.testId;

    this.syncronizeStorage();

    this.state = {
      passedTests: this.passedTests,
    }
  }

  popup = createRef();

  onButtonClick = function (buttonIndex) {
    gameControlButtons[buttonIndex].click();
    this.syncronizeStorage();
    this.setState({
      passedTests: this.passedTests,
    })
  };

  syncronizeStorage = function () {
    const currentTest = this.props.testId;
    this.passedTests = JSON.parse(('localStorage' in window && this._LS_PASSED_GAMES_KEY in localStorage) ? localStorage[this._LS_PASSED_GAMES_KEY] : '[]');
    if (this.passedTests.indexOf(currentTest.toString()) === -1) {
      this.passedTests.push(currentTest);
    }
    if ('localStorage' in window) {
      localStorage[this._LS_PASSED_GAMES_KEY] = JSON.stringify(this.passedTests);
    }
  };

  markComplete(id) {
    for (let i = 0; i < TESTS_NUMBER; i++) {
      if (this.passedTests[i] === id.toString()) {return true}
    }
    return false;
  }

  render() {
    return (
      <ul className="content__final-buttons">
        {Array(TESTS_NUMBER).fill().map((element, i) => <li>
          <button onClick={() => this.onButtonClick(i)} disabled={this.markComplete(i)} className="content__final-button" aria-label={BUTTON_NAMES[i]}>{BUTTON_NAMES[i]}</button>
        </li>)}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./components/passed-tests/index.js